import { createSlice } from "@reduxjs/toolkit";
import { userNormalLogout, supportLogout } from "../actions";

export interface PnlStatementState {
  pnlData: {};
}

const initialState: PnlStatementState = {
  pnlData: {},
};

export const PnlStatementSlice = createSlice({
  name: "pnlStatement",
  initialState,
  reducers: {
    savePnlData: (state, actions) => {
      state.pnlData = actions.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const { savePnlData } = PnlStatementSlice.actions;
export default PnlStatementSlice.reducer;
